import { InMemoryCache, TypePolicy } from '@apollo/client'

/**
 * Objects that are not normalized are instead embedded within their parent object in the cache.
 * You can't access these objects directly in the cache, but you can access them via their parent.
 * We use this for entities under a credit app since most of them do not resolve with an ID, so
 * that we're not overwriting entities that may belong to different credit apps.
 */
const disabledNormalizationCacheOpt: TypePolicy = { keyFields: false }

export const cache = new InMemoryCache({
  possibleTypes: {
    CreditApplication: ['CreditApplicationPaginated'],
  },
  typePolicies: {
    Query: {
      fields: {
        creditApplication: {
          read(_, { args, toReference }) {
            return toReference({
              __typename: 'CreditApplication',
              salesforceCreditId: args?.creditApplicationId ?? '',
            })
          },
        },
        creditApplicationsPaginated: {
          keyArgs: false,
        },
      },
    },
    BankInfo: disabledNormalizationCacheOpt,
    Contact: { keyFields: ['contactId'] },
    CreditApplicationPaginatedConnection: {
      fields: {
        edges: {
          keyArgs: false,
          merge(existing = [], incoming, { variables }) {
            if (variables?.after) {
              return [...existing, ...incoming]
            }
            return [...incoming]
          },
        },
      },
    },
    CreditApplicationPaginated: {
      keyFields: (obj) => {
        return `CreditApplication:{"salesforceCreditId":"${obj?.salesforceCreditId}"}`
      },
    },
    CreditApplication: {
      fields: {
        validationErrors: { merge: false },
        businessInfo: {
          merge(existing, incoming, { mergeObjects }) {
            return mergeObjects(existing, incoming)
          },
        },
        financeInfo: {
          merge(existing, incoming, { mergeObjects }) {
            return mergeObjects(existing, incoming)
          },
        },
      },
      keyFields: ['salesforceCreditId'],
    },
    CreditApplicationAddress: disabledNormalizationCacheOpt,
    CreditApplicationBusinessInfo: disabledNormalizationCacheOpt,
    CreditApplicationDocument: { keyFields: ['documentUuid'] },
    CreditApplicationFinanceInfo: disabledNormalizationCacheOpt,
    CreditApplicationValidationError: disabledNormalizationCacheOpt,
    PersonaInquiry: { keyFields: ['inquiryId'] },
  },
})
